import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SFetchedFilterSelect = styled.div`
  width: 240px;

  ${setFlexDFFDC};
`;
